"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const join_1 = tslib_1.__importDefault(require("../utils/join"));
const baseClassName = 'ab-EmptyContent';
const EmptyContent = (_a) => {
    var { children, className, style } = _a, flexProps = tslib_1.__rest(_a, ["children", "className", "style"]);
    if (typeof children === 'string') {
        children = React.createElement("p", null, children);
    }
    return (React.createElement(rebass_1.Box, { flex: 1, className: `${baseClassName}__wrapper` },
        React.createElement(rebass_1.Flex, Object.assign({ alignItems: "center", justifyContent: "center", flexDirection: "column" }, flexProps, { className: (0, join_1.default)(baseClassName, className), style: style }), children)));
};
exports.default = EmptyContent;
